"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var use_theme_1 = __importDefault(require("../../../global/use-theme"));
var styled_components_1 = __importDefault(require("styled-components"));
var installation_sketch_constants_1 = __importDefault(require("../installation-sketch-constants"));
var Svg = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  z-index: 3;\n"], ["\n  position: relative;\n  z-index: 3;\n"])));
var InstallationOutline = function (_a) {
    var height = _a.height, width = _a.width;
    var colours = use_theme_1.default().colours;
    return (react_1.default.createElement(Svg, { width: width, height: height, stroke: colours.installationSketch.stroke, strokeWidth: 2, fill: 'none', "data-test-id": 'installation-sketch-outline' },
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { d: "M 0 0 l " + Math.floor(width * installation_sketch_constants_1.default.leftBreakPoint) + " 0 v " + height + " l " + Math.floor(width * installation_sketch_constants_1.default.middleDistance) + " 0 v " + height * -1 + " l " + Math.floor(width * installation_sketch_constants_1.default.rightBreakPoint) + " 0" }))));
};
InstallationOutline.displayName = 'InstallationOutline';
exports.default = InstallationOutline;
var templateObject_1;
